import { upperCase, upperFirst } from 'lodash';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { IMissingInformation } from '../../../pages/ListingDetail/ListingDetail.types';
import { PROPERTY_ATTACHMENT_TYPES } from '../../../shared/constants/propertyAttachmentConstants';
import PropertyAttachmentCalcoloCanoneConcordatoField from '../../PropertyAttachmentsField/PropertyAttachmentCalcoloCanoneConcordatoField';
import PropertyAttachmentsMultiFileHandlerField from '../../PropertyAttachmentsField/PropertyAttachmentsMultiFileHandlerField/PropertyAttachmentsMultiFileHandlerField';
import { IPropertyAttachmentDocument } from '../../PropertyAttachmentsField/PropertyAttachmentsMultiFileHandlerField/PropertyAttachmentsMultiFileHandlerField.types';
import PropertyAttachmentsSingleFileHandlerField from '../../PropertyAttachmentsField/PropertyAttachmentsSingleFileHandlerField';
import {
  StyledLabel,
  StyledListingDocumentWrapper,
} from './ListingDocuments.styles';
import { filterMissingListingDocuments } from './utils/filterMissingListingDocuments';

const ListingDocuments = ({
  setMissingDocumentInformation,
}: {
  setMissingDocumentInformation: Dispatch<
    SetStateAction<IMissingInformation | null>
  >;
}) => {
  const { listingId } = useParams();
  const { t } = useTranslation(['listingDetail']);
  const [apeDocument, setApeDocument] =
    useState<IPropertyAttachmentDocument | null>(null);

  useEffect(() => {
    const missingDocuments = filterMissingListingDocuments(apeDocument);
    if (missingDocuments.fields.length === 0) {
      setMissingDocumentInformation(null);
      return;
    }
    setMissingDocumentInformation(missingDocuments);
  }, [apeDocument]);

  return (
    <StyledListingDocumentWrapper>
      <div>
        <StyledLabel>{upperCase(t('listingDetail:ape'))}</StyledLabel>
        <PropertyAttachmentsSingleFileHandlerField
          title={upperCase('APE')}
          type={PROPERTY_ATTACHMENT_TYPES.APE}
          property_id={Number(listingId)!}
          setApeDocument={setApeDocument}
        />
      </div>

      <div>
        <StyledLabel>
          {upperFirst(t('listingDetail:otherDocuments'))}
        </StyledLabel>
        <PropertyAttachmentsMultiFileHandlerField
          title={upperFirst(t('listingDetail:otherDocuments'))}
          type={PROPERTY_ATTACHMENT_TYPES.OTHER}
          property_id={Number(listingId)!}
        />
      </div>

      <div>
        <PropertyAttachmentCalcoloCanoneConcordatoField
          title={upperFirst(t('listingDetail:agreedFeeCalculation'))}
          type={PROPERTY_ATTACHMENT_TYPES.CALCOLO_CONORDATO}
          property_id={Number(listingId)!}
        />
      </div>
    </StyledListingDocumentWrapper>
  );
};

export default ListingDocuments;
